import { render, staticRenderFns } from "./DaysSelect.vue?vue&type=template&id=137b006f&scoped=true&"
import script from "./DaysSelect.vue?vue&type=script&lang=js&"
export * from "./DaysSelect.vue?vue&type=script&lang=js&"
import style0 from "./DaysSelect.vue?vue&type=style&index=0&id=137b006f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137b006f",
  null
  
)

export default component.exports